import { useLayoutEffect, useRef } from "react";
import { ArrowUpRight, X } from "lucide-react";
import ProjectArtwork from "./ProjectArtwork";
export default function ProjectDialog({ project, onClose, opener }) {
  const dialogRef = useRef(null);
  useLayoutEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
      dialog.close();
      if (opener instanceof HTMLElement) opener.focus({ preventScroll: true });
    };
  }, [opener]);
  return (
    <dialog
      className="project-dialog"
      ref={dialogRef}
      aria-labelledby="dialog-title"
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="dialog-inner">
        <div className="dialog-top">
          <span className="mono">PROJECT NOTES / {project.number}</span>
          <button
            className="dialog-close"
            onClick={onClose}
            aria-label="Close project notes"
          >
            <X size={23} />
          </button>
        </div>
        <div className={`dialog-art cover-${project.cover}`}>
          <ProjectArtwork kind={project.cover} />
        </div>
        <span className="dialog-art-caption mono">
          CONCEPTUAL PROJECT ILLUSTRATION
        </span>
        <div className="dialog-content">
          <span className="mono accent">{project.discipline}</span>
          <h2 id="dialog-title">{project.title}</h2>
          <p className="dialog-intro">{project.intro}</p>
          <h3>The question</h3>
          <p>{project.challenge}</p>
          <h3>The work</h3>
          <p>{project.contribution}</p>
          <h3>What stays with me</h3>
          <p>{project.reflection}</p>
          <div className="dialog-stack">
            <span className="mono">BUILT WITH</span>
            <p>{project.stack}</p>
          </div>
          <p className="dialog-outcome">{project.outcome}</p>
          {project.link && (
            <a
              className="primary-link"
              href={project.link}
              target="_blank"
              rel="noreferrer"
            >
              {project.linkLabel} <ArrowUpRight size={17} />
            </a>
          )}
        </div>
      </div>
    </dialog>
  );
}
